// Permission keys stored in public.roles.permissions. Keep in sync with the
// roles_permissions_check constraint in supabase/schemas/01_tables.sql.
export const PERMISSIONS = [
  "leads.all",
  "leads.own",
  "leads.transfer",
  "apartments.edit",
  "dashboard",
  "import",
  "settings",
  "team",
] as const;

export type Permission = (typeof PERMISSIONS)[number];

// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

const LEADS: Permission[] = ["leads.all", "leads.own"];

// Which permissions open each UI resource (any of them is enough).
// "dashboard" and "import" are pages, not data resources. Row-level limits
// (own leads only, no buyer data for the admin) are enforced by RLS.
const resourcePermissions: Record<string, Permission[]> = {
  dashboard: ["dashboard"],
  sales: ["team"],
  configuration: ["settings"],
  roles: ["settings"],
  import: ["import"],
  contacts: LEADS,
  companies: LEADS,
  deals: LEADS,
  tasks: LEADS,
  contact_notes: LEADS,
  deal_notes: LEADS,
  tags: LEADS,
  apartments: [...LEADS, "apartments.edit"],
};

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  permissions: readonly string[] | undefined,
  params: CanAccessParams<RecordType>,
) => {
  const required = resourcePermissions[params.resource];
  if (!required || !permissions) return false;
  return required.some((permission) => permissions.includes(permission));
};
